import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'form-row',
  templateUrl: './form-row.component.html',
  styleUrls: ['./form-row.component.css']
})
export class FormRowComponent implements OnInit {

  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Input() inline: boolean = false;
  @Input() canDelete: boolean = true;
  constructor() { }

  ngOnInit() {
  }

  public handleDelete() {
    this.onDelete.emit();
  }

}
